import { BaseComponent, elementBaseComponent } from './base';
import { urlAPI } from '../../../shared/api';
import { getSpinner } from '../elements';
import { loadImage, audioPlayWord } from '../../../shared/services';
import { svgDifficult, svgLearning } from '../../../shared/svg';
import { controllers } from '../../../controllers/controller';
import { model } from '../../../model/model';
var classButtonPlaySound = 'button button__icon button__icon-play';
// const data: TWordBody = {
//   difficulty: '0',
//   optional: {
//     testFieldString: '0',
//     isNew: true,
//     correctlyGuessed: 0,
//     incorrectlyGuessed: 0,
//   },
// };
var Word = /** @class */ (function () {
    function Word(body, signIn, statistics, isDifficult, isLearning) {
        if (isDifficult === void 0) { isDifficult = false; }
        if (isLearning === void 0) { isLearning = false; }
        this.body = body;
        this.signIn = signIn;
        this.statistics = statistics;
        this.isDifficult = isDifficult;
        this.isLearning = isLearning;
        this.card = new BaseComponent('li');
        this.buttonPlayWord = new BaseComponent('button');
        this.buttonPlaySentense = new BaseComponent('button');
        this.buttonPlayExample = new BaseComponent('button');
        this.buttonWordDifficult = new BaseComponent('button');
        this.buttonWordLearned = new BaseComponent('button');
    }
    Word.prototype.show = function () {
        var _this = this;
        var srcImage = "".concat(urlAPI, "/").concat(this.body.image);
        var srcAudioWord = "".concat(urlAPI, "/").concat(this.body.audio);
        var srcAudioExample = "".concat(urlAPI, "/").concat(this.body.audioExample);
        var srcAudioSentense = "".concat(urlAPI, "/").concat(this.body.audioMeaning);
        var picture = document.createElement('figure');
        var image = document.createElement('img');
        var caption = document.createElement('figcaption');
        var textHeader = document.createElement('p');
        var textStatic = document.createElement('p');
        var textSentenseEnglish = document.createElement('p');
        var textSentenseTranslate = document.createElement('p');
        var textExampleEnglish = document.createElement('p');
        var textExampleTranslate = document.createElement('p');
        var spinner = getSpinner.add();
        image.alt = "picture association ".concat(this.body.word);
        loadImage(srcImage)
            .then(function (data) {
            image.src = srcImage;
            // picture.append(image)
            if (data)
                _this.hideSpinner();
            return data;
        })
            .then(function (data) {
            picture.classList.add('no-blur');
        })
            .catch(function (error) {
            image.alt = "undefined picter's";
        });
        textHeader.className = 'word__header-text';
        this.buttonPlayWord.element.className = classButtonPlaySound;
        this.buttonPlaySentense.element.className = classButtonPlaySound;
        this.buttonPlayExample.element.className = classButtonPlaySound;
        this.buttonWordDifficult.element.className = 'button button__icon button__icon-difficult';
        this.buttonWordLearned.element.className = 'button button__icon button__icon-learned';
        textSentenseEnglish.className = 'sentense__english';
        textSentenseTranslate.className = 'sentense__translate';
        textExampleEnglish.className = 'example__english';
        textExampleTranslate.className = 'example__translate';
        caption.textContent = this.body.word;
        textHeader.insertAdjacentHTML('afterbegin', "<span>".concat(this.body.transcription, "</span><span>").concat(this.body.wordTranslate, "</span>"));
        textStatic.className = this.signIn ? 'word__static open' : 'word__static';
        textStatic.insertAdjacentHTML('afterbegin', "\u0432\u0435\u0440\u043D\u043E <span class=\"word__static-true\">".concat(this.statistics[0], "</span> / <span class=\"word__static-true\">").concat(this.statistics[1], "</span> \u043D\u0435 \u0432\u0435\u0440\u043D\u043E"));
        textSentenseEnglish.insertAdjacentHTML('afterbegin', this.body.textMeaning);
        textSentenseTranslate.textContent = this.body.textMeaningTranslate;
        textExampleEnglish.insertAdjacentHTML('afterbegin', this.body.textExample);
        textExampleTranslate.textContent = this.body.textExampleTranslate;
        picture.append(image, caption);
        this.buttonWordDifficult.element.insertAdjacentHTML('afterbegin', svgDifficult());
        this.buttonWordLearned.element.insertAdjacentHTML('afterbegin', svgLearning());
        var blockImage = elementBaseComponent('div', ['word__image'], [picture]);
        var blockWordIcons = this.signIn
            ? elementBaseComponent('div', ['word__icons'], [this.buttonWordDifficult.element, this.buttonWordLearned.element])
            : elementBaseComponent('div', ['word__icons'], []);
        var blockHeader = elementBaseComponent('div', ['word__header'], [this.buttonPlayWord.element, textHeader, blockWordIcons.element, textStatic]);
        var blockSentense = elementBaseComponent('div', ['word__sentense'], [this.buttonPlaySentense.element, textSentenseEnglish, textSentenseTranslate]);
        var blockExample = elementBaseComponent('div', ['word__example'], [this.buttonPlayExample.element, textExampleEnglish, textExampleTranslate]);
        var blockDescription = elementBaseComponent('div', ['word__description'], [blockHeader.element, blockSentense.element, blockExample.element]);
        this.buttonPlayWord.element.addEventListener('click', function () {
            audioPlayWord(srcAudioWord);
        });
        this.buttonPlaySentense.element.addEventListener('click', function () {
            audioPlayWord(srcAudioSentense);
        });
        this.buttonPlayExample.element.addEventListener('click', function () {
            audioPlayWord(srcAudioExample);
        });
        this.card.element.className = 'word';
        this.card.element.append(blockImage.element, blockDescription.element, spinner);
        return this.card;
    };
    Word.prototype.showSpinner = function () {
        var spinnerElement = this.card.element.querySelector('.loading');
        if (!spinnerElement.classList.contains('active'))
            spinnerElement.classList.add('active');
    };
    Word.prototype.hideSpinner = function () {
        var spinnerElement = this.card.element.querySelector('.loading');
        if (spinnerElement.classList.contains('active'))
            spinnerElement.classList.remove('active');
    };
    Word.prototype.renderIcon = function () {
        var defaultColor = '#C4C4C4';
        var colorIconDifficult = this.isDifficult ? 'red' : defaultColor;
        var colorIconLearning = this.isLearning ? 'green' : defaultColor;
        while (this.buttonWordDifficult.element.firstChild) {
            this.buttonWordDifficult.element.removeChild(this.buttonWordDifficult.element.firstChild);
        }
        while (this.buttonWordLearned.element.firstChild) {
            this.buttonWordLearned.element.removeChild(this.buttonWordLearned.element.firstChild);
        }
        this.buttonWordDifficult.element.insertAdjacentHTML('afterbegin', svgDifficult(colorIconDifficult));
        this.buttonWordLearned.element.insertAdjacentHTML('afterbegin', svgLearning(colorIconLearning));
    };
    Word.prototype.handleClick = function () {
        var _this = this;
        this.buttonWordDifficult.element.addEventListener('click', function () {
            if ((!_this.isDifficult && !_this.isLearning) || controllers.wordsGroup === '6') {
                _this.isDifficult = !_this.isDifficult;
            }
            if (controllers.wordsGroup === '6') {
                if (_this.isDifficult && _this.buttonWordDifficult.element.classList.contains('check')) {
                    _this.buttonWordDifficult.element.classList.remove('check');
                    // this.data.difficulty = '0';
                    // model.updateUserWord(this.body.id, this.data);
                }
            }
            if (_this.isDifficult && !_this.buttonWordDifficult.element.classList.contains('check')) {
                _this.data.difficulty = 'hard';
                if (_this.data.optional.testFieldStatus) {
                    _this.data.optional.testFieldStatus = false;
                    model.createUserWord(_this.body.id, _this.data).finally(function () {
                        if (!_this.isDifficult && _this.buttonWordDifficult.element.classList.contains('check'))
                            _this.buttonWordDifficult.element.classList.remove('check');
                    });
                }
                else {
                    model.updateUserWord(_this.body.id, _this.data).finally(function () {
                        if (!_this.isDifficult &&
                            !_this.isLearning &&
                            _this.buttonWordDifficult.element.classList.contains('check'))
                            _this.buttonWordDifficult.element.classList.remove('check');
                    });
                }
            }
            else if (!_this.isDifficult && !_this.buttonWordDifficult.element.classList.contains('check')) {
                _this.data.difficulty = '';
                _this.data.optional.testFieldStatus = true;
                model.deleteUserWord(_this.body.id).finally(function () {
                    if (!_this.isDifficult &&
                        !_this.isLearning &&
                        _this.buttonWordDifficult.element.classList.contains('check'))
                        _this.buttonWordDifficult.element.classList.remove('check');
                });
            }
            if (_this.isDifficult &&
                controllers.wordsGroup !== '6' &&
                !_this.buttonWordDifficult.element.classList.contains('check')) {
                _this.buttonWordDifficult.element.classList.add('check');
            }
            _this.renderIcon();
        });
        this.buttonWordLearned.element.addEventListener('click', function () {
            if (!_this.buttonWordLearned.element.classList.contains('check'))
                _this.buttonWordLearned.element.classList.add('check');
            _this.isLearning = !_this.isLearning;
            _this.isDifficult = false;
            if (!_this.buttonWordDifficult.element.classList.contains('check') &&
                controllers.wordsGroup !== '6')
                _this.buttonWordDifficult.element.classList.add('check');
            if (!_this.isLearning && _this.buttonWordDifficult.element.classList.contains('check'))
                _this.buttonWordDifficult.element.classList.remove('check');
            if (_this.isLearning) {
                _this.data.difficulty = 'easy';
                if (_this.data.optional.testFieldStatus) {
                    _this.data.optional.testFieldStatus = false;
                    model.createUserWord(_this.body.id, _this.data).finally(function () {
                        if (_this.buttonWordLearned.element.classList.contains('check'))
                            _this.buttonWordLearned.element.classList.remove('check');
                    });
                }
                else {
                    model.updateUserWord(_this.body.id, _this.data).finally(function () {
                        if (_this.buttonWordLearned.element.classList.contains('check'))
                            _this.buttonWordLearned.element.classList.remove('check');
                    });
                }
            }
            else {
                _this.data.difficulty = '';
                _this.data.optional.testFieldStatus = true;
                model
                    .deleteUserWord(_this.body.id)
                    .then(function (data) { return data; })
                    .catch(function (err) {
                    console.error(err);
                })
                    .finally(function () {
                    if (_this.buttonWordLearned.element.classList.contains('check'))
                        _this.buttonWordLearned.element.classList.remove('check');
                });
            }
            _this.renderIcon();
        });
    };
    Word.prototype.init = function () {
        var _this = this;
        this.data = {
            difficulty: '',
            optional: {
                testFieldString: '0',
                testFieldStatus: true,
            },
        };
        if (controllers.userWords.length > 0) {
            controllers.userWords.forEach(function (user) {
                if (user.wordId === _this.body.id) {
                    var data = model
                        .getUserWord(_this.body.id)
                        .then(function (data) {
                        var res = data;
                        _this.data = {
                            difficulty: res.difficulty,
                            optional: res.optional,
                        };
                        if (_this.data.difficulty === 'hard') {
                            _this.isDifficult = true;
                            if (_this.isDifficult &&
                                !_this.buttonWordDifficult.element.classList.contains('check') &&
                                controllers.wordsGroup !== '6') {
                                _this.buttonWordDifficult.element.classList.add('check');
                                // model.createUserWord(this.body.id,)
                            }
                        }
                        if (_this.data.difficulty === 'easy') {
                            _this.isLearning = true;
                            _this.isDifficult = false;
                            if (!_this.isDifficult &&
                                !_this.buttonWordDifficult.element.classList.contains('check') &&
                                controllers.wordsGroup !== '6') {
                                _this.buttonWordDifficult.element.classList.add('check');
                                // model.createUserWord(this.body.id,)
                            }
                        }
                        _this.renderIcon();
                    })
                        .catch(function (err) {
                        _this.renderIcon();
                    });
                }
            });
        }
        this.handleClick();
        this.renderIcon();
    };
    return Word;
}());
export { Word };
